import { render } from "./SystemManagement.vue?vue&type=template&id=0aa2d92d&scoped=true"
import script from "./SystemManagement.vue?vue&type=script&lang=js"
export * from "./SystemManagement.vue?vue&type=script&lang=js"

import "./SystemManagement.vue?vue&type=style&index=0&id=0aa2d92d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa2d92d"]])

export default __exports__